import React from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { SiBuzzfeed } from "react-icons/si";

const SubMenus = ({ data, isOpen, toggleSubMenu }) => {
  const location = useLocation();

  const renderSubIcon = (icon, isActive) => {
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, {
        className: `inline-block ${isActive ? "text-white" : "text-gray-500"}`,
        style: { color: isActive ? "white" : "red" },
      });
    }
    return icon;
  };

  const isSubmenuActive = (route) => {
    return location.pathname.replaceAll("%20", " ").includes(route);
  };

  return (
    <>
      <li
        className={`flex justify-center text-xs items-center gap-2 cursor-pointer`}
        onClick={toggleSubMenu}
      >
        {data?.icon}
        <p className="capitalize flex-1">{data?.name}</p>
        <RiArrowDropDownLine
          size={23}
          className={`transform transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </li>
      <motion.ul
        animate={isOpen ? { height: "fit-content" } : { height: 0 }}
        className="flex flex-col mt-4 pl-0 text-large font-normal overflow-hidden rounded-lg"
      >
        {data?.menus?.map((item, index) => (
          <NavLink
            key={index}
            to={item?.route}
            state={item?.rowData}
            className={`flex items-center text-xs gap-2 p-2 ${isSubmenuActive(item?.name)
              ? "bg-primary text-white px-4 text-md font-medium"
              : "bg-black px-4"
              }`}
          >
            {renderSubIcon(item?.icon, item?.name, isSubmenuActive(item?.name))}
            {item?.name}
          </NavLink>
        ))}
      </motion.ul >
    </>
  );
};

export default SubMenus;